import {BillPaymentSummaryApiDto} from "../../api/model/rest";

export default class BillPaymentSummary {

	constructor(public readonly id: string,
		public readonly billId: string,
		public readonly referenceNumber: string,
		public readonly due: number,
		public readonly total: number,
		public readonly paymentAmount: number,
		public readonly partnerName: string,
		public readonly canUndoReconciliation: boolean) {}

	static fromJson(json: BillPaymentSummaryApiDto): BillPaymentSummary {
		return new BillPaymentSummary(json.id, json.billId, json.referenceNumber, json.due, json.total, json.paymentAmount,
			json.partnerName, json.canUndoReconciliation);
	}
}
